if (!customElements.get('ggc-lifestyle-carousel')) {
  customElements.define('ggc-lifestyle-carousel', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.track = this.querySelector('.ggc-photos__track');
      this.slides = Array.from(this.querySelectorAll('.ggc-photos__slide'));
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      if (!this.track || !this.slides.length) return;
      this.querySelector('.ggc-photos__controls').hidden = this.slides.length < 2;
      const update = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.track.addEventListener('scroll', update, { ...options, passive: true });
      this.previous.addEventListener('click', () => this.move(-1), options);
      this.next.addEventListener('click', () => this.move(1), options);
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
        event.preventDefault();
        if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this.slides.length - 1);
        else this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(this.track);
      this.update();
    }
    positions() {
      const start = this.slides[0].offsetLeft;
      return this.slides.map(slide => slide.offsetLeft - start);
    }
    update() {
      const max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const left = this.track.scrollLeft;
      this.previous.disabled = left <= 2;
      this.next.disabled = left >= max - 2;
      const positions = this.positions();
      this.index = positions.reduce((nearest, position, index) => Math.abs(position - left) < Math.abs(positions[nearest] - left) ? index : nearest, 0);
      const visible = this.slides.map((slide, index) => ({index, start:positions[index], end:positions[index] + slide.clientWidth})).filter(slide => slide.start < left + this.track.clientWidth - 2 && slide.end > left + 2);
      if (visible.length) {
        const first = visible[0].index + 1;
        const last = visible[visible.length - 1].index + 1;
        this.querySelector('[data-status]').textContent = `${first === last ? first : `${first}–${last}`} / ${this.slides.length}`;
      }
    }
    move(direction) {
      const positions = this.positions();
      const left = this.track.scrollLeft;
      const target = direction > 0 ? positions.findIndex(position => position > left + 2) : positions.findLastIndex(position => position < left - 2);
      this.go(target < 0 ? (direction > 0 ? this.slides.length - 1 : 0) : target);
    }
    go(index) {
      this.track.scrollTo({left:this.positions()[Math.max(0, Math.min(index, this.slides.length - 1))], behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
